import React from "react";
import "../../../pitch-deck-analysis.css";
import { Accordion, Card } from "react-bootstrap";
import { FaEllipsisH, FaChevronDown } from "react-icons/fa";
function ViewManagement(props) {
  return (
    <>
      <Accordion
        className="companyaccordion"
        defaultActiveKey="leadershipAndTeam"
      >
        <Accordion.Item eventKey="leadershipAndTeam">
          <Accordion.Header className="companycardheader">
            <div className="companyarrowicon">
              <FaChevronDown />
            </div>

            <div className="companytitlecard">Leadership and team</div>

            <div className="companyellipsisicon">
              <FaEllipsisH />
            </div>
          </Accordion.Header>
          <Accordion.Body id="companyinformation">
            {!props?.management.teamExperience ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">Why you (team experience)?</p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamExperience.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.doFoundersHaveInsightsOfCompetitiveLandscape ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Do the founders have unique insights of the competitive
                  landscape?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.doFoundersHaveInsightsOfCompetitiveLandscape.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.whereTeamWorked ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Where have your team members worked?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.whereTeamWorked.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamExperienceAmount ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  How much experience do they have?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamExperienceAmount.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.contactsInTarget ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Who are their contacts in your target or related industries?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.contactsInTarget.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.workDoneRelatingToBusiness ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What work have they done that relates directly to this
                  proposed business?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.workDoneRelatingToBusiness.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamAccomplishments ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What have they accomplished?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamAccomplishments.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamSchool ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Where did they go to school?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamSchool.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamAchievements ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What are their achievements?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamAchievements.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamProvenTrackRecord ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Do they have a proven track record?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamProvenTrackRecord.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamAbilities ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What knowledge, skills, and special abilities do they bring to
                  the business?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamAbilities.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamReputation ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What is their reputation in the business community?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamReputation.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamIntegrity ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Are they known for their integrity?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamIntegrity.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamDedication ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Do they have a reputation for being hardworking or especially
                  dedicated to their work?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamDedication.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamRealisticAboutSuccess ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Are they realistic about the business's chances for success?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamRealisticAboutSuccess.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamCapableOfRecognizingRisks ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Are they capable of recognizing risks and responding to
                  problems that arise?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamCapableOfRecognizingRisks.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamCourageToMakeDecisions ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Do they have the courage to make the hard decisions that
                  inevitably have to be made?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamCourageToMakeDecisions.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamWhoIsVisionary ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Who on the team is a visionary?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamWhoIsVisionary.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamOfferingCaution ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  Who will offer words of caution?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamOfferingCaution.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.teamCommitmentToVenture ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  How committed are they to this venture?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.teamCommitmentToVenture.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.whatMotivatesTeam ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">What motivates them?</p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.whatMotivatesTeam.map((point, index) =>
                      !point ? (
                        ""
                      ) : (
                        <li className="pitchdeckanswers" key={index}>
                          {point}
                        </li>
                      ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.whatAchievementsTeamWant ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What do they hope to achieve?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.whatAchievementsTeamWant.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
            {!props?.management.whatBenefitsTeamWant ? (
              ""
            ) : (
              <div>
                <p className="companydetailtitle">
                  What benefits do they wish to gain?
                </p>
                <p className="companydetaildata">
                  <ul>
                    {props.management.whatBenefitsTeamWant.map(
                      (point, index) =>
                        !point ? (
                          ""
                        ) : (
                          <li className="pitchdeckanswers" key={index}>
                            {point}
                          </li>
                        ),
                    )}
                  </ul>
                </p>
              </div>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
export default ViewManagement;
